// extracted by mini-css-extract-plugin
module.exports = {"banner-wrap":"Banner_banner-wrap__3qmiT","box":"Banner_box__1cI44"};